import BulletPointIcon from "@/components/_icons/bulletPointIcon";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";

export interface SingleProductDescriptionFocusedDurationProps {
  duration: string;
}

export const SingleProductDescriptionFocusedDuration = ({
  duration,
}: SingleProductDescriptionFocusedDurationProps) => {
  const t = useTranslations("SingleProductDescriptionFocusedDuration");
  const formatDuration = (duration: string) => {
    if (!duration) return "";
    const regex = /PT(?:(\d+)H)?(?:(\d+)M)?/;
    const matches = duration.match(regex);
    const hours =
      matches?.[1] && parseInt(matches[1]) > 0
        ? `${matches[1]} ${t("hr")}`
        : "";
    const minutes =
      matches?.[2] && parseInt(matches[2]) > 0
        ? `${matches[2]} ${t("min")}`
        : "";
    return `${hours}${hours && minutes ? " " : ""}${minutes}`.trim();
  };
  const formattedDuration = formatDuration(duration);
  return (
    <>
      <BulletPointIcon />
      <span
        data-testid={applyDataTestId(pom.products.serviceDuration)}
        className="sm:py-1 text-sm font-medium text-nowrap"
      >
        {formattedDuration}
      </span>
    </>
  );
};
